import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from "react";
const initialState = {
    childrenVisible: false,
};
/**
 * Render children after delay ms
 */
export class DelayedRender extends React.Component {
    constructor() {
        super(...arguments);
        this.timerId = 0;
        this.state = initialState;
    }
    setChildrenVisible() {
        this.setState({ childrenVisible: true });
    }
    componentDidMount() {
        this.timerId = window.setTimeout(() => this.setChildrenVisible(), this.props.delay);
    }
    render() {
        const { childrenVisible } = this.state;
        return _jsx(Fragment, { children: childrenVisible && this.props.children });
    }
    componentWillUnmount() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
        }
    }
}
